
import { OpenRecordSchema } from "slotworks/integration/revolver/schema/close-record-schema";
import GameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import { RecordBuilder } from "slotworks/server/builders/record-builder";

class BalanceRecordBuilder implements RecordBuilder {

    public filter(data: any): boolean {
        let response: OpenRecordSchema;

        if (data && data.data) {
            response = data.data as OpenRecordSchema;
        }

        const hasUserInfo = response && response.USER;
        const isRecovery = response && response.OPEN !== undefined && !GameState.getCurrentGame().getCurrentRecord();

        return hasUserInfo && !isRecovery;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let response: OpenRecordSchema;

        if (data && data.data) {
            response = data.data as OpenRecordSchema;
        }

        if (response.USER) {
            gameplay.balance = response.USER.balance;
        }

        return [];
    }
}

export default new BalanceRecordBuilder();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/builders/records/balance-record-builder.ts